import type { EventqShortcutAction, EventqShortcutKeymap } from '@ecam/eventq-components';
import { provideEventqShortcuts } from '@ecam/eventq-components';

/** Alarm list / View Alarm navigation and flag toggle (feature 362285). */
export const AGENT_SHORTCUT_ACTION_IDS = {
  previous: 'alarmList.previous',
  next: 'alarmList.next',
  toggleFlag: 'alarmList.toggleFlag',
} as const;

export const AGENT_SHORTCUT_ACTIONS: readonly EventqShortcutAction[] = [
  { id: AGENT_SHORTCUT_ACTION_IDS.previous, allowRepeat: true },
  { id: AGENT_SHORTCUT_ACTION_IDS.next, allowRepeat: true },
  { id: AGENT_SHORTCUT_ACTION_IDS.toggleFlag, allowRepeat: false, throttleMs: 300 },
];

export const AGENT_SHORTCUT_DEFAULT_KEYMAP: EventqShortcutKeymap = {
  [AGENT_SHORTCUT_ACTION_IDS.previous]: [{ key: 'ArrowUp' }],
  [AGENT_SHORTCUT_ACTION_IDS.next]: [{ key: 'ArrowDown' }],
  [AGENT_SHORTCUT_ACTION_IDS.toggleFlag]: [{ key: 'Space' }],
};

export function provideAgentShortcuts() {
  return provideEventqShortcuts({
    actions: AGENT_SHORTCUT_ACTIONS,
    defaults: AGENT_SHORTCUT_DEFAULT_KEYMAP,
  });
}
